// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__6KzfO","row":"Node_row__1N2kE","label":"Node_label__2e0bi","footer":"Node_footer__123DY"};